import React from "react";
import { useState } from "react";
import { Avatar, Box, Button, Center, Navbar, Text } from "@mantine/core";
import { Link, NavLink, useLocation } from "react-router-dom";
// import { LinksGroup } from "../NavbarLinksGroup";
import useStyles from "./style";
import { isSubscriptionExpired, performLogout } from "../../utils";
import { useSelector } from "react-redux";
import mixpanel from "mixpanel-browser";
import { DashboardSvg } from "../Svgs/DashboardSvg";
import { FacilitySvg } from "../Svgs/FacilitySvg";
import { StaffIconSvg } from "../Svgs/StaffIconSvg";
import { ClientIconDashboardSvg } from "../Svgs/ClientIconDashboardSvg";
import { TaskSvg } from "../Svgs/TaskSvg";
import { ReportIconSvg } from "../Svgs/ReportIconSvg";
import { LogoutSvg } from "../Svgs/LogoutSvg";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import SettingsIcon from "../Svgs/SettingsIcon";
import BillingiconSvg from "../Svgs/BillingiconSvg";
import BillingInvoiceIconSvg from "../Svgs/BillingInvoiceIconSvg";
import ToolTip from "../ToolTip/ToolTip";
import StaffDashboardSvg from "../Svgs/StaffDashboardSvg";
import { useMediaQuery } from "@mantine/hooks";
import { SkypointLinksGroup } from "../NavbarLinksGroup/SkypointLinksGroup";
import SkypointSvg2 from "../Svgs/SkypointSvg2";
import { ProspectIconSvg } from "../Svgs/ProspectSvg";
import { ProjectMenuSvg } from "../Svgs/ProjectMenuSvg";

export default function SkyPointNavbar({ isSidebarOpen, setIsSidebarOpen }) {
  const { classes } = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const { profile } = useSelector((state) => state?.profile);

  const staffAdminNotSee = [""];
  const staffNotSee = ["Facility", "Staff", "Billing", "Invoice"];
  const isSettingsPage = window.location.pathname.includes("/home/settings");
  const pathNames = window.location.pathname;
  const MobileScreen = useMediaQuery("(max-width: 500px)");
  const data = [
    {
      to: "/home/dashboard-skypoint",
      label: isSidebarOpen && "Home",
      tooltipLabel: "Home",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          {profile?.user?.role === "staff" ||
          profile?.user?.role === "admin" ? (
            <StaffDashboardSvg pathNames={pathNames} />
          ) : (
            <DashboardSvg pathNames={pathNames} />
          )}
        </Box>
      ),
    },
    {
      to: "/home/provider-skypoint",
      label: isSidebarOpen && "Providers",
      tooltipLabel: "Provider",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          <FacilitySvg pathNames={pathNames} />
        </Box>
      ),
    },
    {
      to: "/home/staff-skypoint",
      label: isSidebarOpen && "Staff",
      tooltipLabel: "Staff",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          <StaffIconSvg pathNames={pathNames} />
        </Box>
      ),
    },
    {
      to: "invoices-skypoint",
      label: isSidebarOpen && "Invoice",
      tooltipLabel: "Invoice",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          <BillingInvoiceIconSvg pathNames={pathNames} />
        </Box>
      ),
    },
    {
      to: "report-skypoint",
      label: isSidebarOpen && "Reports",
      tooltipLabel: "Report",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          <ReportIconSvg pathNames={pathNames} />
        </Box>
      ),
    },
    {
      to: "prospect",
      label: isSidebarOpen && "Prospects",
      tooltipLabel: "Prospect",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          <ProspectIconSvg pathNames={pathNames} />
        </Box>
      ),
    },
    {
      to: "project",
      label: isSidebarOpen && "Projects",
      tooltipLabel: "Project",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          <ProjectMenuSvg pathNames={pathNames} />
        </Box>
      ),
    },
  ];

  const links =
    profile?.user?.type !== "staff" ||
    (profile?.user?.type === "staff" && profile?.user?.role === "admin")
      ? data?.map((item, i) => (
          <SkypointLinksGroup
            {...item}
            setIsOpen={setIsOpen}
            key={i}
            isSidebarOpen={isSidebarOpen}
          />
        ))
      : data
          ?.filter(
            ({ tooltipLabel }) =>
              tooltipLabel !== "Invoice" && tooltipLabel !== "Staff"
          )
          ?.map((item, i) => (
            <SkypointLinksGroup
              {...item}
              setIsOpen={setIsOpen}
              key={i}
              isSidebarOpen={isSidebarOpen}
            />
          ));

  const location = useLocation();
  const isDashboardPage =
    location.pathname === "/home/dashboard" || location.pathname === "/home"
      ? true
      : false;

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  // Function to toggle the navbar visibility
  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Navbar
        pt={0}
        width={{
          sm: isSidebarOpen ? 220 : 70,
          md: isSidebarOpen ? 250 : 70,
          lg: isSidebarOpen ? 260 : 70,
          xl: isSidebarOpen ? 280 : 70,
        }}
        p={10}
        className={classes.contractorNavbar}
      >
        <Box
          w="fit-content"
          pt={0}
          pl={{ xs: 0, sm: 0 }}
          pr={{ xs: 10, sm: 0 }}
          className={classes.header}
        >
          <Link
            to={
              isSubscriptionExpired()
                ? "/home/settings?selectedTab=upgrade"
                : "/home/dashboard-skypoint"
            }
            aria-disabled
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                // justifyContent: "space-between",
              }}
            >
              {isSidebarOpen === true ? (
                // <img
                //   src="/assets/images/skypointLogo.png"
                //   alt="Logo"
                //   style={{ width: "100%", marginTop: "10px" }}
                // />
                <Box mt={20}>
                  <SkypointSvg2 />
                </Box>
              ) : (
                <img
                  src="/assets/images/logoIcon.ico"
                  alt="Logo"
                  style={{ width: "80%", marginTop: "20px" }}
                />
              )}
            </div>
          </Link>
          <Button
            onClick={() => setIsSidebarOpen((prev) => !prev)}
            className={classes.openCloseSidebarBtn}
          >
            {isSidebarOpen ? <IoIosArrowBack /> : <IoIosArrowForward />}
          </Button>
        </Box>
        {isSidebarOpen === true ? (
          <Text c={"gray"} ff={"Inter"} fw={"400"} ml={10} fz={12} mb={5}>
            MENU
          </Text>
        ) : (
          ""
        )}

        <Navbar.Section
          grow
          // className="sidebaritem"
          className={`sidebaritem ${classes.mainNavLinks}`}
          style={{ overflowY: "auto", color: "#667085" }}
        >
          {links}
        </Navbar.Section>
        <div style={{ overflowY: "auto" }}>
          <></>
          <Navbar.Section className={classes.footer}>
            {/* Redirect to settings page */}
            <Link
              className={
                isSettingsPage
                  ? `${classes.link} ${classes.linkActive} ${
                      !isSidebarOpen && classes.closedDrawerSettings
                    }`
                  : classes.link
              }
              to={"/home/settings"}
            >
              <Box className={classes.bottomLinksStyling}>
                {isSidebarOpen ? (
                  <>
                    <SettingsIcon />
                    <Text className={classes.bottomLinksText}>Settings</Text>
                  </>
                ) : (
                  <ToolTip
                    position={"right-end"}
                    toolTipLabel={"Settings"}
                    imgsrc={<SettingsIcon />}
                  />
                )}
              </Box>
            </Link>

            <div className={classes.hrElemDiv} />
            {/* Logout user */}

            <Link
              onClick={() => {
                mixpanel.track("Logout");
                // generate new cookie with new distinct_id
                mixpanel.reset();
                performLogout("/");
              }}
              className={classes.link}
              to={"/"}
            >
              <Box className={classes.bottomLinksStyling}>
                {isSidebarOpen ? (
                  <>
                    <LogoutSvg />
                    <Text className={classes.bottomLinksText}>Logout</Text>
                  </>
                ) : (
                  <ToolTip
                    position={"right-end"}
                    toolTipLabel={"Logout"}
                    imgsrc={<LogoutSvg />}
                  />
                )}
              </Box>
            </Link>
          </Navbar.Section>
        </div>
      </Navbar>

      {isOpen ? (
        <div className={classes?.customDrawerOpen}>
          <span onClick={toggleNavbar}>
            <img width={25} src="/assets/images/closeIcon.png" alt="close" />
          </span>
          <div className={classes.drawerContent}>
            <Navbar.Section grow className="sidebaritem">
              <Center className={classes.header}>
                <Link to={"/home"}>
                  <img
                    width={"50%"}
                    src="/assets/images/logoIcon.ico"
                    alt="Logo"
                  />
                </Link>
              </Center>
              {links}
            </Navbar.Section>
            <Navbar.Section className={classes.footer}>
              <Link
                aria-label="logout button"
                className={classes.link}
                to={"/"}
                onClick={() => {
                  mixpanel.track("Logout");
                  // generate new cookie with new distinct_id
                  mixpanel.reset();
                  performLogout("/");
                }}
              >
                <LogoutSvg />
                <span role="button" aria-label="Logout">
                  Logout
                </span>
              </Link>
            </Navbar.Section>
          </div>
        </div>
      ) : (
        <div className={classes.customDrawer}>
          <div className={classes.drawerContent}></div>
        </div>
      )}
      <div className={classes.menuIconContainer}>
        <img
          src="/assets/images/menu.png"
          className={classes?.menu}
          onClick={toggleDrawer}
          alt="menu toggle"
        />
        <NavLink to={"/home/settings"}>
          <Avatar
            size={MobileScreen ? "md" : "lg"}
            radius="xl"
            className={classes?.avatar}
            src={profile?.user?.photo}
          />
        </NavLink>
      </div>
    </>
  );
}
